export interface KV<T = string> {
  label: string;
  value: T;
  [key: string]: any;
}

export const ACCENT_MODES: KV[] = [
  { label: '英式', value: 'BR_E' },
  { label: '美式', value: 'AM_E' },
];

export const COURSEWARE_EDITORS: KV[] = [
  { label: '基础版', value: 'VERSION_1' },
  { label: '进阶版', value: 'VERSION_2' },
];

export const COURSE_EDIT_HIDDEN_FIELDS: KV[] = [
  { label: '公开性', value: 'displayStatus' },
  { label: '可用性', value: 'availableToAll' },
  { label: '版权', value: 'copyright' },
  { label: '学习计划', value: 'supportLearnPlan' },
];

export const DISABLED_DOWNLOAD: KV<boolean>[] = [
  { label: '支持', value: false },
  { label: '不支持', value: true },
];

export const RESOURCE_TYPES: KV[] = [
  { label: '文档', value: 'document' },
  { label: '音频', value: 'audio' },
  { label: '图片', value: 'image' },
  { label: '视频', value: 'video' },
];

export const COURSEWARE_OPERATION_MODES: KV<boolean>[] = [
  { label: '移动', value: true },
  { label: '复制后移动', value: false },
];

export const CHARGING_MODEL: KV<boolean>[] = [
  { label: '免费', value: true },
  { label: '收费', value: false },
];

export const DISPLAY_VALUES: KV[] = [
  { value: 'HIDDEN', label: '隐藏', icon: 'eye-invisible' },
  { value: 'NORMAL', label: '公开', icon: 'eye' },
];
